import { render } from "./CumplimientoPracticas.vue?vue&type=template&id=4aac9362&scoped=true"
import script from "./CumplimientoPracticas.vue?vue&type=script&lang=js"
export * from "./CumplimientoPracticas.vue?vue&type=script&lang=js"

import "./CumplimientoPracticas.vue?vue&type=style&index=0&id=4aac9362&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aac9362"]])

export default __exports__